"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const hooks_1 = require("common/hooks");
const user_default_log_svg_1 = __importDefault(require("../assets/user-default-log.svg"));
const auth_1 = require("common/auth");
const domEvent_1 = require("common/domEvent");
const project_1 = require("utils/project");
const logo_icon_svg_1 = __importDefault(require("../assets/logo-icon.svg"));
const logo_text_svg_1 = __importDefault(require("../assets/logo-text.svg"));
const pages_1 = require("../../../pages");
const NavBar = ({ handleMobileToggle, asideMobileActive, }) => {
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [navMobileActive, setNavMobileActive] = (0, react_1.useState)(false);
    // const { data: user } = useAuthentication();
    const { loading, isAdmin, user } = (0, auth_1.useAdminAuthentication)();
    const { displayName: userName, photoURL: logoUrl, role } = user || {};
    const onClickLogoutHandler = () => {
        (0, auth_1.signOut)();
    };
    const onMobileToggleHandler = (0, react_1.useCallback)(() => {
        setNavMobileActive(!navMobileActive);
    }, [setNavMobileActive, navMobileActive]);
    const navigate = (0, pages_1.useTypedNavigate)();
    const onClickHome = (0, react_1.useCallback)(() => {
        navigate("LIST_PROJECTS");
    }, [navigate]);
    (0, domEvent_1.useDomEvent)(window, ["resize", "scroll"], () => {
        setNavMobileActive(false);
    });
    const projectId = process.env["REACT_APP_FIRE_BASE_PROJECT_ID"];
    const environmentName = {
        "react-app-sample-4fc1e": "開発(社内)",
        "dre-magi-translate-dev": "開発",
        "gcp-dre-magi": "本番",
        unknown: "未指定",
    }[projectId || "unknown"] || projectId;
    return (react_1.default.createElement("nav", { id: "navbar-main", className: (0, classnames_1.default)("navbar", asideMobileActive && "has-aside") },
        react_1.default.createElement("a", { className: "navbar-item is-hidden-desktop jb-aside-mobile-toggle", onClick: handleMobileToggle },
            react_1.default.createElement("span", { className: "icon" },
                react_1.default.createElement("i", { className: (0, classnames_1.default)("mdi", "mdi-24px", { "mdi-forwardburger": !asideMobileActive }, { "mdi-backburger": asideMobileActive }) }))),
        react_1.default.createElement("a", { className: "navbar-item is-hidden-desktop jb-navbar-menu-toggle", "data-target": "navbar-menu", onClick: onMobileToggleHandler },
            react_1.default.createElement("span", { className: "icon" },
                react_1.default.createElement("i", { className: (0, classnames_1.default)("mdi", { "mdi-dots-vertical": !navMobileActive }, { "mdi-close": navMobileActive }) }))),
        react_1.default.createElement("span", { style: { display: "flex", alignItems: "center" } },
            react_1.default.createElement("a", { onClick: onClickHome },
                react_1.default.createElement("img", { style: {
                        height: "32px",
                        marginLeft: "10px",
                        flex: "none",
                        boxSizing: "content-box",
                    }, src: logo_icon_svg_1.default }),
                react_1.default.createElement("img", { style: {
                        height: "25px",
                        flex: "none",
                        marginLeft: "4px",
                        boxSizing: "content-box",
                        paddingBottom: "5px",
                    }, src: logo_text_svg_1.default })),
            react_1.default.createElement("span", { style: {
                    borderRadius: "6px",
                    color: "white",
                    background: "#69BE55",
                    width: "120px",
                    height: "25px",
                    padding: "0px 30px",
                    textAlign: "center",
                    fontFamily: "Noto Sans JP",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "25px",
                    marginLeft: "18px",
                } }, "QA")),
        role === "master" && (react_1.default.createElement("div", { style: {
                margin: "0 5px",
                padding: "5px 8px",
                background: "#eee",
                borderRadius: "10px",
                alignSelf: "center",
                fontWeight: "bold",
                fontSize: "80%",
                color: "#666",
            } }, "\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005")),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("navbar-menu", {
                "is-active": navMobileActive,
            }), id: "navbar-menu" },
            react_1.default.createElement("div", { className: "navbar-end" },
                react_1.default.createElement("div", { className: "navbar-item has-dropdown has-dropdown-with-icons has-divider has-user-avatar is-hoverable" },
                    react_1.default.createElement("a", { className: "navbar-link is-arrowless", style: { minWidth: "120px" } },
                        react_1.default.createElement("div", { className: "is-user-avatar" },
                            react_1.default.createElement("img", { src: logoUrl || user_default_log_svg_1.default, alt: "User profile" })),
                        react_1.default.createElement("div", { className: "is-user-name" },
                            react_1.default.createElement("span", null, userName)),
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-chevron-down" }))),
                    react_1.default.createElement("div", { className: "navbar-dropdown" },
                        project_1.environmentType !== "production" && (react_1.default.createElement("div", { className: "navbar-item" },
                            react_1.default.createElement("span", null,
                                "\u74B0\u5883: ",
                                environmentName))),
                        react_1.default.createElement("div", { className: "navbar-item" },
                            react_1.default.createElement("span", null,
                                "\u6A29\u9650: ",
                                role === "master" ? "システム" : "プロジェクト")),
                        react_1.default.createElement("div", { className: "navbar-item" },
                            react_1.default.createElement("span", null,
                                "\u30D0\u30FC\u30B8\u30E7\u30F3: ",
                                process.env["GITHUB_COMMIT_ID"])),
                        react_1.default.createElement("hr", { className: "navbar-divider" }),
                        react_1.default.createElement("a", { className: "navbar-item", id: "logout", onClick: onClickLogoutHandler },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "mdi mdi-logout" })),
                            react_1.default.createElement("span", null, formatMessage("NavBar.logOut")))))))));
};
exports.default = NavBar;
